var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.716 76.41L55.56 10.335a8.754 8.754 0 0 0-15.12 0L1.284 76.41a8.973 8.973 0 0 0-.078 9.12A8.712 8.712 0 0 0 8.844 90h78.312a8.712 8.712 0 0 0 7.638-4.476 8.97 8.97 0 0 0-.078-9.117v.003zm-5.136 6.147A2.766 2.766 0 0 1 87.156 84H8.844a2.766 2.766 0 0 1-2.424-1.443 3.039 3.039 0 0 1 .024-3.09L45.6 13.401a2.757 2.757 0 0 1 4.8 0l39.156 66.066c.57.949.58 2.133.024 3.09zM54 69a6 6 0 1 1-12 0 6 6 0 0 1 12 0zm0-30.6c.048.449.048.901 0 1.35L52.5 53.1a4.53 4.53 0 0 1-9 0L42 39.75a6.038 6.038 0 1 1 12-1.35z",
    fill: "#13242F",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.86daf725907e347b5c9663178d2f8256.svg";
export { ForwardRef as ReactComponent };